import { GET_ALL_AGENTS, GET_USER_BY_ID } from "../../../config/realstar-api-config";
import axios from "../../axios/axios";

const authorizationKey = process.env.REACT_APP_REALSTAR_AUTHORIZATION; 

export const fetchUserByID = async (userId) => {

  try {
    const response = await axios.get(`${GET_USER_BY_ID}${userId}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });

    if(response.status === 200)
    { 
      const employeeData = response.data.employee
      employeeData.full_name = `${response.data.employee.full_name} (${response.data.employee.display_name})`
      
      return employeeData;
    }
    else
    { return response }
    

  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const fetchAllUsers = async () => {

  try {
    const response = await axios.get(`${GET_ALL_AGENTS}`, {
      headers: {
        Authorization: authorizationKey,
      },
    });

    if(response.status === 200)
    { return response.data.employees }
    else
    { return response }
    

  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};


// let authToken = localStorage.getItem(process.env.REACT_APP_REALSTAR_AUTHORIZATION);
// let tokenExpiration = localStorage.getItem('tokenExpiration');

// export const fetchUserByID = async (userID) => {
  
//     try { 
//           // Check if token is expired or missing
//     if (!authToken || (tokenExpiration && Date.now() > parseInt(tokenExpiration, 10))) {
//       // Handle token refresh or re-authentication here
//       // Example:
//       // const refreshedToken = await refreshToken();
//       // authToken = refreshedToken;
//       // localStorage.setItem('authToken', refreshedToken);
//       // Set token expiration to 1 hour from now
//       tokenExpiration = Date.now() + 10000; // 1 hour in milliseconds
//       localStorage.setItem('tokenExpiration', tokenExpiration.toString());
//     }

//         const response = await axios.get( GET_USER_BY_ID + `NzQ5WmdPTXdPaGVjZ0MxdVBTOHZJQT09` , {
//           headers: {
//             Authorization: authToken ? authToken : process.env.REACT_APP_REALSTAR_AUTHORIZATION,
//           }
//         })
        
//         return response;
        
//       } catch (error) {
//         throw error;
//       }
// }



// export const fetchUserByID = async () => {
//   // Usage example
// const userId = 'NzQ5WmdPTXdPaGVjZ0MxdVBTOHZJQT09';
// const jwtToken = process.env.REACT_APP_REALSTAR_AUTHORIZATION; // Make sure this is stored securely in environment variables
//   try {
//     const response = await axios.get(`${GET_USER_BY_ID}${userId}`, {
//       headers: {
//         Authorization: jwtToken,
//       },
//     });


//     return response;
//   } catch (error) {
//     console.error('Error fetching user data:', error);
//     throw error;
//   }
// };


